"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSubmitOrder = exports.postPaymentProviderInput = exports.postPayment = exports.postOrderPaidByVoucher = exports.postSaferpayToken = exports.postSaferpayAlt = exports.getSaferpayAltStatus = exports.postPaymentOptionId = exports.getPaymentInfo = exports.postClickAndCollectStoreId = exports.getStoresForGeoLocation = exports.postPickupPoint = exports.getPickupPoints = exports.postDelivery = exports.postDeliveryOption = exports.getDeliveryInfo = exports.postDeliveryCountry = exports.getDeliveryCountries = exports.initRequest = exports.CheckoutVersion = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const common_types_1 = require("@as-react/common-types");
const common_utils_1 = require("@as-react/common-utils");
const createUrl_1 = require("../../utils/createUrl");
var CheckoutVersion;
(function (CheckoutVersion) {
    CheckoutVersion[CheckoutVersion["OLD"] = 1] = "OLD";
    CheckoutVersion[CheckoutVersion["NEW"] = 2] = "NEW";
})(CheckoutVersion || (exports.CheckoutVersion = CheckoutVersion = {}));
const checkoutEndpoints = {
    initiate: { client: 'api/checkout/initiate' },
    contact: { client: 'api/checkout/contact' },
    dtmCheckoutStep: { client: 'api/dtm/checkoutstep' },
    getDeliveryCountries: { client: 'api/deliverycharges/countries/{mainWebshop}/{shopId}' },
    postDeliveryCountry: { client: 'api/buy/delivery/country/{countryId}' },
    getDeliveryInfo: { client: 'api/buy/delivery' },
    postDeliveryOption: { client: 'api/buy/delivery/option/{deliveryOption}' },
    postDelivery: { client: 'api/buy/delivery' },
    getPickupPoints: { client: 'api/pickup/postcode' },
    postPickupPoint: { client: 'api/buy/pickup/v2' },
    collectInStore: { client: 'api/buy/delivery/clickandcollect' },
    getPaymentInfo: { client: 'api/buy/payment' },
    postPaymentOptionId: { client: 'api/buy/payment/option/{optionId}' },
    getSaferpayAltStatus: { client: 'api/buy/status/saferpay/alternative' },
    postSaferpayAlt: { client: 'api/buy/input/saferpay/alternative' },
    postSaferpayToken: { client: 'api/buy/input/saferpay/token' },
    postOrderPaidByVoucher: { client: 'api/buy/payment/voucher' },
    postPayment: { client: 'api/buy/payment/v2' },
    postPaymentProviderInput: { client: 'api/buy/input/{provider}' },
    postSubmitOrder: { client: 'api/buy/submit/{provider}' },
};
const initRequest = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.initiate, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
        data: {
            adobeUuid: common_utils_1.CookieUtil.get(common_types_1.Cookie._UUID),
            visitorId: common_utils_1.CookieUtil.getByRegexp(/^AMCV_.+AdobeOrg/i),
            userAgent: navigator.userAgent,
            fredhopperSegment: common_utils_1.CookieUtil.get(common_types_1.Cookie.FREDHOPPER_SEGMENT),
            consentSetting: common_utils_1.CookieUtil.get(common_types_1.Cookie.CONSENT_SETTING),
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.initRequest = initRequest;
const getDeliveryCountries = (_b) => tslib_1.__awaiter(void 0, [_b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getDeliveryCountries, isServer, {
        mainWebshop: defaultRequestParams.mainWebshop,
        shopId: defaultRequestParams.shopId,
    });
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getDeliveryCountries = getDeliveryCountries;
const postDeliveryCountry = (_c, countryId_1) => tslib_1.__awaiter(void 0, [_c, countryId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, countryId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postDeliveryCountry, isServer, {
        countryId,
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postDeliveryCountry = postDeliveryCountry;
const getDeliveryInfo = (_d, countryId_2) => tslib_1.__awaiter(void 0, [_d, countryId_2], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, countryId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getDeliveryInfo, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { countryId }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getDeliveryInfo = getDeliveryInfo;
const postDeliveryOption = (_e, deliveryOption_1) => tslib_1.__awaiter(void 0, [_e, deliveryOption_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, deliveryOption) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postDeliveryOption, isServer, {
        deliveryOption,
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    yield axios_1.default.request(axiosConfig);
});
exports.postDeliveryOption = postDeliveryOption;
const postDelivery = (_f, deliveryInfo_1) => tslib_1.__awaiter(void 0, [_f, deliveryInfo_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, deliveryInfo) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postDelivery, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        data: deliveryInfo,
    };
    yield axios_1.default.request(axiosConfig);
});
exports.postDelivery = postDelivery;
const getPickupPoints = (_g, _h) => tslib_1.__awaiter(void 0, [_g, _h], void 0, function* ({ servicesEndpoint, isServer }, { postcode, provider, countryCode, deliveryDate, limit }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getPickupPoints, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: { postcode, provider, countryCode, deliveryDate, limit },
        withCredentials: true,
    };
    return yield axios_1.default.request(axiosConfig);
});
exports.getPickupPoints = getPickupPoints;
const postPickupPoint = (_j, _k) => tslib_1.__awaiter(void 0, [_j, _k], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { pickupPoint, provider, countryCode }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPickupPoint, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { provider }),
        data: Object.assign(Object.assign({}, pickupPoint), { countryCode }),
        withCredentials: true,
    };
    return yield axios_1.default.request(axiosConfig);
});
exports.postPickupPoint = postPickupPoint;
const getStoresForGeoLocation = (_l, _m_1) => tslib_1.__awaiter(void 0, [_l, _m_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, _m) {
    var { fasciaFirst = false } = _m, params = tslib_1.__rest(_m, ["fasciaFirst"]);
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.collectInStore, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign(Object.assign({}, defaultRequestParams), params), { fasciaFirst }),
        withCredentials: true,
    };
    const answer = yield axios_1.default.request(axiosConfig);
    return answer.data;
});
exports.getStoresForGeoLocation = getStoresForGeoLocation;
const postClickAndCollectStoreId = (_o, storeId_1) => tslib_1.__awaiter(void 0, [_o, storeId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, storeId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.collectInStore, isServer);
    common_utils_1.CookieUtil.set(common_types_1.Cookie.CLICK_AND_COLLECT_STORE, storeId.toString(), { secure: true });
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { storeId }),
        withCredentials: true,
    };
    return axios_1.default.request(axiosConfig);
});
exports.postClickAndCollectStoreId = postClickAndCollectStoreId;
const getPaymentInfo = (_p) => tslib_1.__awaiter(void 0, [_p], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getPaymentInfo, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getPaymentInfo = getPaymentInfo;
const postPaymentOptionId = (_q, optionId_1) => tslib_1.__awaiter(void 0, [_q, optionId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, optionId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPaymentOptionId, isServer, {
        optionId,
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postPaymentOptionId = postPaymentOptionId;
const getSaferpayAltStatus = (_r, requestId_1) => tslib_1.__awaiter(void 0, [_r, requestId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, requestId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getSaferpayAltStatus, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { requestId, checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getSaferpayAltStatus = getSaferpayAltStatus;
const postSaferpayAlt = (_s) => tslib_1.__awaiter(void 0, [_s], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSaferpayAlt, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSaferpayAlt = postSaferpayAlt;
const postSaferpayToken = (_t, _u) => tslib_1.__awaiter(void 0, [_t, _u], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { token, saveForFutureUse = false }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSaferpayToken, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        data: {
            saferpayFieldsToken: token,
            saveForFutureUse: saveForFutureUse,
            checkoutVersion: CheckoutVersion.NEW,
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSaferpayToken = postSaferpayToken;
const postOrderPaidByVoucher = (_v) => tslib_1.__awaiter(void 0, [_v], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postOrderPaidByVoucher, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postOrderPaidByVoucher = postOrderPaidByVoucher;
const postPayment = (_w, data_1) => tslib_1.__awaiter(void 0, [_w, data_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, data) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPayment, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        data,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postPayment = postPayment;
const postPaymentProviderInput = (_x, provider_1) => tslib_1.__awaiter(void 0, [_x, provider_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, provider) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPaymentProviderInput, isServer, {
        provider: provider.toLowerCase(),
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postPaymentProviderInput = postPaymentProviderInput;
const postSubmitOrder = (_y, _z) => tslib_1.__awaiter(void 0, [_y, _z], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { provider, authorizationToken }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSubmitOrder, isServer, {
        provider: provider.toLowerCase(),
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { authorizationToken, checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSubmitOrder = postSubmitOrder;
//# sourceMappingURL=checkout.api.js.map